/* LuxeCollar – Aufklapp-Bereiche sanft öffnen und schließen (Niklas 16.10.2026: „die Dropdown-Funktion muss sich auch sanft öffnen“).
   Gilt für die Aufklapp-Bereiche des Themes (Produktseite „Fertigung und Lieferung“, „Material und Pflege“ …, Häufige Fragen). Menü und Filter bleiben unberührt.
   Bei „Bewegung reduzieren“ öffnet es wie bisher ohne Bewegung. Zum Entfernen die Zeile mit lc-sanft.js in sections/header-group.json löschen. */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE='cubic-bezier(.22,.61,.36,1)';
  var st=document.createElement('style');
  st.textContent='@media (prefers-reduced-motion:no-preference){.accordion summary .icon-caret{transition:transform .38s '+EASE+'}.accordion details.lc-zu>summary .icon-caret{transform:none!important}}';
  document.head.appendChild(st);
  document.addEventListener('click',function(e){
    var summary=e.target.closest&&e.target.closest('.accordion details > summary');
    if(!summary||reduce.matches)return;
    var d=summary.parentElement;
    if(!d.animate||d.closest('header-drawer, menu-drawer, .facets, .menu-drawer'))return;
    e.preventDefault();
    var content=summary.nextElementSibling;
    var opening=!d.open||d.classList.contains('lc-zu');
    /* overflow vor dem Messen setzen (Niklas 16.10. 13:17: „dann wird nochmal eine Zeile extra abgehakt“): Der Inhalt hat 15 px Abstand nach unten; ohne overflow liegt der außerhalb des Kastens, mit overflow innerhalb. Gemessen wurde vorher ohne, animiert mit – am Ende sprang der Bereich um diese 15 px. */
    d.style.overflow='hidden';
    var from=d.getBoundingClientRect().height;
    if(d._lcAnim){d._lcAnim.cancel();d._lcAnim=null}
    if(d._lcFade){d._lcFade.cancel();d._lcFade=null}
    d.classList.remove('lc-zu');
    d.open=true;
    var to=opening?d.getBoundingClientRect().height:summary.getBoundingClientRect().height;
    if(!opening)d.classList.add('lc-zu');
    summary.setAttribute('aria-expanded',opening?'true':'false');
    var anim=d.animate({height:[from+'px',to+'px']},{duration:opening?400:320,easing:EASE,fill:opening?'none':'forwards'});
    d._lcAnim=anim;
    if(opening&&content&&content.animate)d._lcFade=content.animate({opacity:[0,1],transform:['translateY(-6px)','none']},{duration:400,easing:EASE});
    anim.onfinish=function(){
      d._lcAnim=null;d.style.overflow='';
      if(!opening){d.open=false;d.classList.remove('lc-zu');anim.cancel()}
    };
  });
})();
